import React, { Component, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action, AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState } from '../.././Componet';
import { useParams } from "react-router-dom";
import { Route } from "react-router-dom";
import { Modal } from 'bootstrap';
import { data } from 'jquery';



function AttachPage(props) {
    let id = useParams().id;
    const [pageState, setState] = useState({records:[],isLoaded:false});
    let objectType = useParams().objectType;
    const upload = () => {
        let cx = document.getElementById('txtfilename');
        let formData = new FormData();
        formData.append('objectTypeId', objectType);
        formData.append('id', id);
        for (let i = 0; i < cx.files.length; i++) {
            formData.append('files', cx.files[i], cx.files[i].value);
        }
        let h = new Helper();
        h.AjaxForUpload('Attacher', 'Insert', formData, (data) => {
            h.Alert(data.message);
            if(data.status==200)
            {
                $('txtfilename').val(null);
                load();
            }

        });
    };
    const load = () => {
        let h = new Helper();
        h.Ajax('Attacher', 'List', { objectTypeId: objectType, id: id },
            (data) => {
                setState({ records: data, isLoaded:true });
            }

        )

    };
    const Download = (record) => {
        window.open('/Attacher/Download?guid=' + record.guid);

    }
    const Delete = (record) => {
        let h = new Helper();
         h.ConfirmAction(FixedMessage.AreYouSure, 'پرسش', () => {
            h.Ajax('Attacher', 'Delete', { guid: record.guid }, (data) => {
                h.MessageBox(data.message, '');
                if (data.status == '200') {
                    load();
                }
            })

        });           



    };
    if (pageState.isLoaded == false) {
        load();
    }
    return <FromBasic >
        <FormDiv size="100%" >
            فایل ها <input type="file" id="txtfilename" multiple></input>
            <SimpleButton title="ارسال" onClick={upload} />
        </FormDiv>
        <ProTable Records={pageState.records} datasourcename='files'>
            <Column metaForDisplay={DataClass.Attachment.RealName} />
            <Column metaForDisplay={DataClass.Attachment.UserName} />
            <Column metaForDisplay={DataClass.Attachment.CreateTime} />
            <Action caption="دریافت" type="function" targetFun={Download} />
            <Action caption="حذف" type="function" targetFun={Delete} />

        </ProTable>
    </FromBasic>

}


export function AttacherApp(props) {
    let routes = [
        <Route path="Attachs/:objectType/:id" element={<AttachPage />}></Route>,
    ]
    return routes;
}